// extracted by mini-css-extract-plugin
export var label = "_du-1";
export var reminder = "_du-0";